module.exports = __webpack_public_path__ + "static/media/photo_gallery_icon.040a173a.JPG";